import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle response errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const requestUrl = error.config?.url || '';

      // 1. Skip auto-logout for Razorpay payment requests
      const razorpayPaths = ['/razorpay/create-order', '/razorpay/verify-payment'];
      const isRazorpayError = razorpayPaths.some((path) => requestUrl.includes(path));

      // 2. Skip auto-logout when the user is trying to log in/register with wrong credentials
      const authPaths = ['/auth/login', '/auth/register'];
      const isAuthRequest = authPaths.some((path) => requestUrl.includes(path));

      if (!isRazorpayError && !isAuthRequest) {
        // Clear auth storage
        localStorage.removeItem('token');
        localStorage.removeItem('user');

        // Redirect to login only if not already on the login page
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;